import axios from "axios";
import config from "../../config";
import axiosInstance from "../../utils/axiosInstance";


const BookHighlightManager = {
  async getAllHighlights() {
    const response = await axiosInstance.get("/highlights");
    return response.data.responseData;
  },

  async getHighlightById(id) {
    const response = await axiosInstance.get(`highlights/${id}`);
    return response.data.responseData;
  },

  async createHighlight(highlight) {
    const response = await axiosInstance.post("/highlights", highlight);
    return response.data.responseData;
  },

  async updateHighlight(id, highlight) {
    const response = await axiosInstance.put(`/highlights/${id}`, highlight);
    return response.data.responseData;
  },

  async deleteHighlight(id) {
    const response = await axiosInstance.delete(`/highlights/${id}`);
    return response.data.responseData;
  },

  async getHighlightsByType(type) {
    const response = await axiosInstance.get(`/highlights/type/${type}`);
    return response.data.responseData;
  },

  async getBookOfTheMonth(userId = null) {
    const response = await axiosInstance.post(`/highlights/book-of-the-month`, {
      userId,
    });
    return response.data.responseData;
  },

  async getJustLaunchedBooks(userId = null) {
    const response = await axiosInstance.post(`/highlights/just-launched`, {
      userId,
    });
    return response.data.responseData;
  },

  async getTrendingBooks(userId = null) {
    const response = await axiosInstance.post(`/highlights/trending`, {
      userId,
    });
    return response.data.responseData;
  },

  async getBestReadsBooks(userId = null) {
    const response = await axiosInstance.post(`/highlights/best-reads`, {
      userId,
    });
    return response.data.responseData;
  },
};

export default BookHighlightManager;
